module.exports = __webpack_public_path__ + "img/1800-2_YR_2022_Smishing.591088b6.png";